import { FC, useState } from "react";
import { INomenclatureData } from "Data/interfaces/Nomenclatura/INomenclatureData";
import { IObraNomenclaturesRequest } from "Data/interfaces/Obra/IObraNomenclaturas";
import { INomenclatureObraData } from "Data/interfaces/Obra/ICreateOrUpdate";
import NomenclaturaForm from "Components/UI/NomenclaturaForm";
import toastHandler from 'Utils/toastHandler';
import { useQueryUpdateNomenclatureObra } from "Hooks/obras/useQueryUpdateNomenclatureObra";
import { Container, Main, Title } from "./styles";

interface INomenclature {
  csId: number;
  loading?: boolean;
  obraVersionData?: INomenclatureData;
  versionConfigFk?: number;
  hasValidateStagesInNomenclature?: boolean;
}

const Nomenclature: FC<INomenclature> = ({
  csId,
  loading,
  obraVersionData,
  versionConfigFk,
  hasValidateStagesInNomenclature,
}) => {
  const { updateNomenclatureObra } = useQueryUpdateNomenclatureObra();

  const [showEdit, setShowEdit] = useState(false);

  const handleSubmit = (values?: INomenclatureObraData, erros?: string[]) => {
    erros?.forEach((error) => {
      toastHandler.handler({ description: error, icon: 'error', title: '' });
    });

    if (!showEdit || !values || erros) return;

    const request: IObraNomenclaturesRequest = {
      constructionStieId: csId,
      nomenclatures: {
        isVersionControlDefault: values.isVersionControlDefault,
        versionConfig: {
          hasRevisionControl: values.VersionConfig.HasRevisionControl,
          versionFields: values.VersionConfig.VersionFields.map(field => ({
            ordem: field.Ordem,
            campoPersonalizado: field.CampoPersonalizado,
            separador: field.Separador,
            campoVersaoId: field.CampoVersaoId,
          })),
        },
      },
    };
    updateNomenclatureObra(request);
  }

  return (
    <Container>
      <Title>Nomenclatura</Title>
      <Main>
        <NomenclaturaForm
          isEditObra
          obraVersionData={obraVersionData}
          versionConfigFk={versionConfigFk}
          isTabVersion
          showEditObra={showEdit}
          showEditLoading={loading}
          hasValidateStagesInNomenclature={hasValidateStagesInNomenclature}
          onShow={() => setShowEdit(true)}
          onCancel={() => setShowEdit(false)}
          onSubmit={handleSubmit}
        />
      </Main>
    </Container>
  )
}

export default Nomenclature;
